import {
  ManualAdjustmentKey,
  ORCHESTRATE_AUTOFILL_PROPERTY_API,
  OrderFeature,
  schSourceType,
} from '@aloft/toolkit-shared';
import { Opts } from '@aloft/toolkit-sui';

import { Path } from 'react-hook-form';
import { z } from 'zod';

export type PropertyGridType = 'FeatureGrid' | 'AdjustmentsGrid';

export type PropertyGridColumnSectionComponent = React.ComponentType<PropertyGridSectionProps>;

const schColumnType = schSourceType.or(z.literal('property'));
export type ColumnType = z.infer<typeof schColumnType>;

export const schPropertyGridColumnDefinition = z.object({
  propertyId: z.string(),
  type: schColumnType,
  propertyData: ORCHESTRATE_AUTOFILL_PROPERTY_API.GET.RESPONSE.optional(),
});

export type PropertyGridColumnDefinition = z.infer<typeof schPropertyGridColumnDefinition>;

export const schPropertyGridForm = z.object({
  columns: z.array(schPropertyGridColumnDefinition),
  dataSources: z.array(schSourceType),
});

export type PropertyGridForm = z.infer<typeof schPropertyGridForm>;

export type PropertyGridRowFieldType =
  | 'dataSourceValue'
  | 'label'
  | 'editableValue'
  | 'editableArvValue'
  | 'readOnlyValue'
  | 'adjustment';

export type PropertyGridSectionProps = {
  columnIndex: number;
  fieldTypes: PropertyGridRowFieldType[];
  feature?: OrderFeature;
  isRemovable?: boolean;
  hasSeparateArvValue?: boolean;
  onRemove?: () => void;
};

export type PropertyGridFieldName = Path<PropertyGridForm['columns'][number]['propertyData']>;

export type PropertyGridField<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T = any,
  U extends string | number = T extends string | number ? T : string,
> = {
  fieldName: PropertyGridFieldName;
  label: string;
  manualAdjustmentKey?: ManualAdjustmentKey;
  options?: Opts<U>; // For enum fields
  includeEmptyOption?: boolean;
  autofillSubjectValue?: boolean;
  toDisplayValue?: (value?: T) => string | undefined;
  toEditValue?: (value?: T) => string | undefined;
  toValue?: (value?: string) => T | undefined;
};
